import {useCallback, useState} from "react";
import axios from "axios";

import {acknowledgeMissingReportNotice, getMissingReportNotices} from "@services/travelAllowance/ride.service";
import {MissingReportNotice} from "@models/travelAllowance/ride";
import {getWorkerId} from "@utils/tools/worker";

const useMissingReportNotices = () => {
    const [notices, setNotices] = useState<MissingReportNotice[]>([]);
    const [isVisible, setIsVisible] = useState<boolean>(false);

    const refresh = useCallback(async () => {
        const workerId = await getWorkerId();

        if (!workerId) {
            return;
        }

        const cancelToken = axios.CancelToken.source();

        try {
            const data = await getMissingReportNotices(cancelToken);
            setNotices(data);
            setIsVisible(data.length > 0);
        } catch (e) {
            console.error(e);
        }
    }, []);

    const acknowledgeCurrent = useCallback(async () => {
        const current = notices[0];

        if (!current) {
            return;
        }

        setIsVisible(false);

        try {
            await acknowledgeMissingReportNotice(current.rideId);
        } catch (e) {
            console.error(e);
        }
    }, [notices]);

    const showNext = useCallback(() => {
        setNotices((prev) => {
            const remaining = prev.slice(1);
            setIsVisible(remaining.length > 0);

            return remaining;
        });
    }, []);

    return {
        currentNotice: isVisible ? notices[0] : undefined,
        refresh,
        acknowledgeCurrent,
        showNext,
    };
};

export default useMissingReportNotices;
